import './tag.styles';

import { getTemplateData } from '@/scripts/utils/cms';

import initPage from '@/scripts/init/init';
import initBlogLayout from '@/layouts/blog/blog-layout';
import ImgLazyLoad from '@/scripts/lib/ImgLazyLoad';
import Pagination from '@/components/Pagination/Pagination';


const $page = document.querySelector('.tag-js');
const $pagination = $page.querySelector('.pagination-js');

const page = getTemplateData('page');
const maxPage = getTemplateData('maxPage');

initPage();
initBlogLayout();
new ImgLazyLoad(document.querySelectorAll('img.lazy'));

const pagination = new Pagination($pagination, { manualRouting: false });
pagination.cur = page;
pagination.pages = maxPage;
pagination.render();


(function setHumEvents(){
   if (!window.humTracker) return;
   
   humTracker.trackScroll($page, 'tag scroll');
   humTracker.trackClick($pagination, 'tag pagination click');
  
}());
